import { Trans } from '~/common/context';
import { useManageQuoteBrandTemplates } from '~/connect/api';
import { BaseCustomerBrandsForm } from '~/connect/components';
import { CustomerUtils } from '~/connect/helpers';
import { CustomerFormProps } from '~/connect/hooks';

const QuoteBrandsForm = ({ forms, internalCriteria }: CustomerFormProps) => {
  const watchedCriteria =
    forms[CustomerUtils.CRITERIA_STEP].methods.watch('criteria');
  const hasSelectedCriteria =
    watchedCriteria.length > 0 &&
    watchedCriteria.every(
      (criterion) => criterion.criterion.id && criterion.value,
    );

  const manageQuoteBrandTemplates = useManageQuoteBrandTemplates({
    getMatched: {
      enabled: hasSelectedCriteria,
      args: {
        customerCriteria: watchedCriteria.map(({ criterion, value }) => ({
          id: criterion.id,
          valueId: value,
        })),
        customerInternalCriteria: internalCriteria,
      },
    },
  });

  return (
    <BaseCustomerBrandsForm
      isLoading={manageQuoteBrandTemplates.getMatched.isFetching}
      brandTemplateLabel={<Trans i18nKey='app.entity.tab.quote_brands' />}
      matchedBrandTemplate={manageQuoteBrandTemplates.getMatched.data?.data}
    />
  );
};

export default QuoteBrandsForm;
